// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from 'recoil';

// Import Material UI
import { Button } from "@material-ui/core";

// Import Pages
import Modal from "../../../../components/Modal/Modal";
import TextField from "../../../../components/TextField/TextField";
import AutoCompleteField from "./AutoCompleteField";
import AutomService from "../../../../services/AutomService/AutomService";
import ProfileService from "../../../../services/ProfileService/ProfileService";
import { alertState } from "./../../../../recoil-store/recoil-state";

// Import CSS
import '../AlertManagement.css';

const AddAlertProfile = ({ setOpen, setRefresh, edit }) => {
  const { t } = useTranslation();
  const [automList, setAutomList] = useState([]);
  const [actionProfileList, setActionProfileList] = useState([]);
  const [alertRuleList, setAlertRuleList] = useState([]);
  const [orjinalData, setOrjinalData] = useState([]);
  const setAlert = useSetRecoilState(alertState);
  const label = 'CONTENT.ALERT.';
  const labelActioneer = 'CONTENT.ACTIONEER-PROFILE.';
  const [editData, setEditData] = useState({
    createDatas: {
      alert_rules: [],
      automs: [],
      actioneer_profiles: [],
    },
    deleteDatas: {
      alert_rules: [],
      automs: [],
      actioneer_profiles: [],
    }
  });

  const [state, setState] = useState({
    name: "",
    description: "",
    alert_rules: [],
    actioneer_profiles: [],
    is_all_automs: true,
    automs: [],
  });

  useEffect(() => {
    const fetchAutomList = async () => {
      const response = await AutomService.getAutomNameList();
      if (response) {
        if (response?.data) {
          setAutomList(response.data);
        }
      }
    };
    fetchAutomList().then((r) => r);

    const fetchAction = async () => {
      const response = await ProfileService.getAllActioneersProfile();
      if (response) {
        if (response?.data) {
          setActionProfileList(response.data);
        }
      }
    };
    fetchAction().then((r) => r);

    const fetchRules = async () => {
      const response = await ProfileService.getAllAlertRules();
      if (response) {
        if (response?.status) {
          setAlertRuleList(response.data);
        }
      }
    };
    fetchRules().then((r) => r);

    if (edit?.type === "edit") {
      const fetchData = async () => {
        const response = await ProfileService.getAlertProfile(edit.id);
        if (response) {
          if (response?.data) {
            setState({
              name: response.data?.name,
              description: response.data?.description,
              is_all_automs: response.data?.is_all_automs,
              actioneer_profiles: response.data?.actioneer_profiles,
              alert_rules: response.data?.alert_rules,
              automs: response.data?.automs
            });
            if (edit?.type === "edit") {
              setOrjinalData(response.data)
            }
          }
        }
      };
      fetchData().then((r) => r);
    }
  }, []);

  const handleChange = (event) => {
    if (event.target.value !== ' ') {
      setState({ ...state, [event.target.name]: event.target.value });
    }
  };

  const checkValidForm = () => {
    let isValid = true;
    if ((!state.name || state.name === '') ||
      (!state.alert_rules || state.alert_rules.length < 1) ||
      (!state.actioneer_profiles || state.actioneer_profiles.length < 1) ||
      (!state.is_all_automs && (!state.automs || state.automs.length < 1))) {
      setAlert(alert => ({ ...alert, show: true, message: t(labelActioneer + 'FILL-IN-THE-BLANKS'), severity: 'error' }))
      isValid = false;
    }
    return isValid;
  }

  const handleAdd = async () => {
    if (checkValidForm()) {
      const filterAction = state?.actioneer_profiles?.map((action) => action.id);
      const filterAutom = state?.automs?.map((action) => action.id);
      const filterRules = state?.alert_rules?.map((action) => action.id);

      const newData = {
        ...state,
        name: state.name.trim(),
        actioneer_profiles: filterAction,
        automs: filterAutom,
        alert_rules: filterRules,
      };
      const response = await ProfileService.addAlertProfile(newData);
      if (response) {
        if (response?.status) {
          //success
          setRefresh((old) => !old);
          setOpen(false);
        }
        setAlert(alert => ({ ...alert, show: true, message: t(label + response.message), severity: response.status ? 'success' : 'error' }))
      }
    }
  };

  // const editFilterData = (data, arr, key, filterArr, type) => {
  //   if (type === "add") {
  //     for (let k of editData[arr][key]) {
  //       if (!filterArr?.includes(k.id)) {
  //         data[key].push(k.id);
  //       }
  //     }
  //   } else {
  //     const filters = editData[arr][key]?.map((action) => action.id);
  //     if (filters?.length > 0) {
  //       for (let i = 0; i < filterArr.length; i++) {
  //         // const element = filterArr[i];
  //         if (!(filters?.includes(filterArr[i]))) {
  //           data[key].push(filterArr[i]);
  //         }
  //       }
  //       // for (let k in filterArr) {

  //       // }
  //     }
  //     // if (orjinalData[key]?.length === editData[arr][key]?.length) {
  //     //   const filter = orjinalData[key]?.map(action => action.id);
  //     //   data[key] = filter?.length === 0 ? [] : filter;
  //     // }

  //   }
  // };



  const createOrDelete = (field_name, initial_v, current_v, createDatas, deleteDatas) => {
    for (const cur of current_v) {
      if (!initial_v.find(x => x === cur)) {
        createDatas[field_name].push(cur);
      }
    }

    for (const orj of initial_v) {
      if (!current_v.find(x => x === orj)) {
        deleteDatas[field_name].push(orj);
      }
    }
  }

  const handleEdit = async () => {
    if (checkValidForm()) {
      const initialAction = orjinalData?.actioneer_profiles?.map((action) => action.id);
      const initialAutom = orjinalData?.automs?.map((action) => action.id);
      const initialRules = orjinalData?.alert_rules?.map((action) => action.id);

      const currentAction = state?.actioneer_profiles?.map((action) => action.id);
      const currentAutom = state?.automs?.map((action) => action.id);
      const currentRules = state?.alert_rules?.map((action) => action.id);

      const createDatas = {
        automs: [],
        alert_rules: [],
        actioneer_profiles: []
      }
      const deleteDatas = {
        automs: [],
        alert_rules: [],
        actioneer_profiles: []
      }


      createOrDelete('actioneer_profiles', initialAction, currentAction, createDatas, deleteDatas);
      createOrDelete('alert_rules', initialRules, currentRules, createDatas, deleteDatas);
      if (state.is_all_automs) {
        deleteDatas.automs = initialAutom;
      } else {
        createOrDelete('automs', initialAutom, currentAutom, createDatas, deleteDatas);
      }
      // editFilterData(createDatas, "createDatas", "alert_rules", filterRules, "add");
      // editFilterData(createDatas, "createDatas", "automs", filterAutom, "add");
      // editFilterData(createDatas, "createDatas", "actioneer_profiles", filterAction, "add")


      // editFilterData(deleteDatas, "deleteDatas", "actioneer_profiles", filterAction, "remove")
      // editFilterData(deleteDatas, "deleteDatas", "automs", filterAutom, "remove");
      // editFilterData(deleteDatas, "deleteDatas", "alert_rules", filterRules, "remove");

      // if (state.is_all_automs) {
      //   deleteDatas.automs = filterAutom;
      // }
      const datas = {
        createDatas,
        deleteDatas,
        name: state.name.trim(),
        description: state.description,
        is_all_automs: state.is_all_automs,
      }


      if (edit?.id) {
        const response = await ProfileService.updateAlertProfile(edit?.id, datas)
        if (response) {
          if (response?.status) {
            setRefresh(old => !old);
            setOpen(false);
          }
          setAlert(alert => ({ ...alert, show: true, message: t(label + response.message), severity: response.status ? 'success' : 'error' }))
        }
      }
    }
  };


  return (
    <Modal title={t(label + "ADD-ALERT-PROFILE")} setOpen={setOpen}>
      <div style={{ marginLeft: 15 }}>
        <div className="form-element">
          <div>{t(label + "NAME")}<span className="mandatory-field">*</span></div>
          <TextField name="name" value={state.name} onChange={handleChange} />
        </div>
        <div className="form-element">
          <div>{t(label + "DESC")}</div>
          <TextField
            name="description"
            value={state.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-element">
          <div>{t(label + "RULES")}<span className="mandatory-field">*</span></div>
          <AutoCompleteField
            state={state}
            params="alert_rules"
            listKey="message"
            data={alertRuleList}
            setState={setState}
            edit={edit}
            editData={editData}
            setEditData={setEditData}
            orjinalData={orjinalData}
          />
        </div>
        <div className="mail-server-button-group" style={{ minWidth: 150 }}>
          <div
            onClick={() => setState({ ...state, is_all_automs: true })}
            className={
              state.is_all_automs
                ? "mail-server-button-active"
                : "mail-server-button"
            }
            style={{ fontSize: 12, minWidth: 75 }}
          >
            {t(label + "SELECT-ALL")}
          </div>
          <div
            onClick={() => setState({ ...state, is_all_automs: false })}
            className={
              !state.is_all_automs
                ? "mail-server-button-active"
                : "mail-server-button"
            }
          >
            {t(label + "CUSTOM")}
          </div>
        </div>
        {!state.is_all_automs ? (
          <div className="form-element">
            <div>{t(label + "AUTOMS")}<span className="mandatory-field">*</span></div>
            <AutoCompleteField
              state={state}
              params="automs"
              listKey="name"
              data={automList}
              setState={setState}
              edit={edit}
              editData={editData}
              setEditData={setEditData}
              orjinalData={orjinalData}
            />
          </div>//
        ) : null}
        <div className="form-element">
          <div>{t(label + "ACTIONEER-PROFILE")}<span className="mandatory-field">*</span></div>
          <AutoCompleteField
            state={state}
            params="actioneer_profiles"
            listKey="name"
            data={actionProfileList}
            setState={setState}
            edit={edit}
            editData={editData}
            setEditData={setEditData}
            orjinalData={orjinalData}
          />
        </div>
      </div>
      <div className="alert-management-footer">
        <Button type="button" onClick={(() => setOpen(false))} className="footer-button cancel w-48p">
          {t(labelActioneer + 'CANCEL')}
        </Button>

        {edit?.type === "edit" ? (
          <Button
            className="footer-button submit w-48p"
            onClick={handleEdit}
          >
            {t(labelActioneer + "EDIT")}
          </Button>

        ) : (
          <Button
            className="footer-button submit w-48p"
            onClick={handleAdd}
          >
            {t(labelActioneer + "ADD")}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default AddAlertProfile;
